import React, { useEffect } from 'react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import Box from '@node-space/storybook-components/dist/Box'
import { SummaryRow } from '@node-space/storybook-components/dist/SummaryDetail'
import { Button } from '@node-space/ui-components'
import { MovePayload } from 'pages/Customers/types'
import { walletActionAtom } from 'pages/Wallets/components/Pay/atoms/atoms'
import { useInternalTransferDetails } from './hooks/useInternalTransferDetails'

interface MoveConfirmProps {
  formValues: MovePayload
  isLoading: boolean
  handleSubmit: () => void
  onBack: () => void
}

export const MoveConfirm = ({ formValues, isLoading, handleSubmit, onBack }: MoveConfirmProps) => {
  const { t } = useTranslation()
  const [walletAction, setWalletAction] = useAtom(walletActionAtom)
  const { onClose: handleClose } = walletAction || {}

  useEffect(() => {
    if (onBack) {
      setWalletAction({
        ...walletAction,
        onBack,
      })
    }
  }, [])

  const moveConfirmationDetails = useInternalTransferDetails(formValues)

  return (
    <Box paddingX={24} className="my-6 w-full space-y-4 text-gray-100">
      <Box className="border border-gray-04 bg-white px-4 py-2">
        {moveConfirmationDetails.map((row, index) => (
          <SummaryRow
            key={index}
            label={row.label}
            description={row.description}
            testid={row.testid}
          />
        ))}
      </Box>
      <Box className="flex justify-between pt-2">
        <Button variant="secondary" onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button onClick={handleSubmit} loading={isLoading}>
          {t('continue')}
        </Button>
      </Box>
    </Box>
  )
}
